module.exports = __webpack_public_path__ + "img/DSC_2728-xl.881ce0c6.png";